<template>
	<section class="view-signup-favoritegames">
		<header class="stepped-overlay-header">
			<ChalkyBrandingBadge size="md" />
			<h3>What do you shoot?</h3>
			<p>Select the games you prefer</p>
		</header>

		<section class="fields stepped-overlay-content">
			<fieldset class="games-played">
				<label>
					<input type="checkbox" v-model="userModel.plays8Ball" />
					<img src="~@chalkysticks/sass/build/asset/image/game-type/8-ball.webp" />
					<span>8 Ball</span>
				</label>

				<label>
					<input type="checkbox" v-model="userModel.plays9Ball" />
					<img src="~@chalkysticks/sass/build/asset/image/game-type/9-ball.webp" />
					<span>9 Ball</span>
				</label>

				<label>
					<input type="checkbox" v-model="userModel.plays10Ball" />
					<img src="~@chalkysticks/sass/build/asset/image/game-type/10-ball.webp" />
					<span>10 Ball</span>
				</label>

				<label>
					<input type="checkbox" v-model="userModel.playsArtistic" />
					<img src="~@chalkysticks/sass/build/asset/image/game-type/artistic.webp" />
					<span>Artistic</span>
				</label>

				<label>
					<input type="checkbox" v-model="userModel.playsBanks" />
					<img src="~@chalkysticks/sass/build/asset/image/game-type/banks.webp" />
					<span>Banks</span>
				</label>

				<label>
					<input type="checkbox" v-model="userModel.playsSnooker" />
					<img src="~@chalkysticks/sass/build/asset/image/game-type/snooker.webp" />
					<span>Snooker</span>
				</label>

				<!-- <label>
							<input type="checkbox" v-model="userModel.playsOneCushion" />
							<span>One Cushion</span>
						</label> -->

				<label>
					<input type="checkbox" v-model="userModel.playsPyramid" />
					<img src="~@chalkysticks/sass/build/asset/image/game-type/pyramid.webp" />
					<span>Pyramid</span>
				</label>

				<label>
					<input type="checkbox" v-model="userModel.playStraight" />
					<img src="~@chalkysticks/sass/build/asset/image/game-type/straight-pool.webp" />
					<span>Straight Pool</span>
				</label>

				<label>
					<input type="checkbox" v-model="userModel.playsBilliards" />
					<img src="~@chalkysticks/sass/build/asset/image/game-type/billiards.webp" />
					<span>Billiards</span>
				</label>

				<label>
					<input type="checkbox" v-model="userModel.playsKillers" />
					<img src="~@chalkysticks/sass/build/asset/image/game-type/killers.webp" />
					<span>Killers</span>
				</label>

				<label>
					<input type="checkbox" v-model="userModel.playsOnePocket" />
					<img src="~@chalkysticks/sass/build/asset/image/game-type/one-pocket.webp" />
					<span>One Pocket</span>
				</label>

				<label>
					<input type="checkbox" v-model="userModel.playsRotation" />
					<img src="~@chalkysticks/sass/build/asset/image/game-type/rotation.webp" />
					<span>Rotation</span>
				</label>
			</fieldset>
		</section>

		<section class="actions stepped-overlay-actions">
			<button class="skip button-secondary" v-on:click="Handle_OnClickSkip">Skip</button>
			<button class="continue button-primary" v-on:click="Handle_OnClickContinue">Continue</button>
		</section>
	</section>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';
	import { beforeDestroy, mounted } from '@/Utility/Decorators';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Signup
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewSignupFavoriteGames extends ViewBase {
		/**
		 * @type ChalkySticks.Model.User
		 */
		@Prop()
		protected userModel!: ChalkySticks.Model.User;

		/**
		 * @return void
		 */
		protected next(): void {
			// this.$router.push({ params: { step: 'profile-photo' } });
			this.$router.push({ params: { step: 'favorite-places' } });
		}

		/**
		 * Skip to the app
		 *
		 * @return void
		 */
		protected skip(): void {
			this.$router.push({ params: { step: 'confirmation' } });
		}

		// region: Event Handlers
		// ---------------------------------------------------------------------------

		/**
		 * @param PointerEvent e
		 * @return Promise<void>
		 */
		public async Handle_OnClickContinue(e: PointerEvent): Promise<void> {
			e.preventDefault();

			// Validate the current form state
			await this.userModel.auth().save();

			// If validation passes, proceed to next step
			this.next();
		}

		/**
		 * @param PointerEvent e
		 * @return Promise<void>
		 */
		public async Handle_OnClickSkip(e: PointerEvent): Promise<void> {
			e.preventDefault();

			this.skip();
		}

		// endregion: Event Handlers
	}
</script>

<style lang="scss">
	.view-signup-favoritegames {
		.games-played {
			display: grid;
			grid-template-columns: 1fr 1fr 1fr;
			grid-template-rows: auto;
			gap: 0.5rem;
			text-align: center;

			label {
				margin: 0.5rem 0;
			}

			span {
				text-transform: uppercase;
			}

			.switch,
			input {
				display: none;
			}

			img {
				border-radius: 1.5rem;
				display: block;
				margin: 0 auto;
				max-width: 96px;
				width: 100%;
				margin-bottom: 1rem;
			}

			input:checked + img {
				border: 4px solid var(--chalky-white);
			}
		}
	}
</style>
